import { render, staticRenderFns } from "./MarketplaceProductsEdit.vue?vue&type=template&id=320d2d70&scoped=true"
import script from "./MarketplaceProductsEdit.vue?vue&type=script&lang=js"
export * from "./MarketplaceProductsEdit.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceProductsEdit.vue?vue&type=style&index=0&id=320d2d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320d2d70",
  null
  
)

export default component.exports